import { render, staticRenderFns } from "./HeaderComp.vue?vue&type=template&id=3e622ea8&scoped=true&"
import script from "./HeaderComp.vue?vue&type=script&lang=js&"
export * from "./HeaderComp.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComp.vue?vue&type=style&index=0&id=3e622ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e622ea8",
  null
  
)

export default component.exports